<template>
  <ActiveBacklog
    v-if="!details"
    :lgSize="12"
    :lgOffset="0"
    :locParam="1"
    :idCity="0"
    @detailView="switchView"
  ></ActiveBacklog>
  <ActiveBacklog2
    v-else
    :lgSize="12"
    :lgOffset="0"
    :locParam="1"
    :idCity="0"
    :details="1"
    @detailView="switchView"
    @modalLocation="modalLocation"
  ></ActiveBacklog2>
</template>

<script>
import ActiveBacklog from "../../components/ActiveBacklog-Column";
import ActiveBacklog2 from "../../components/ActiveBacklog-Stacked";
import router from "../../router";
import { allowedPath } from "../../shared/utils";

export default {
  name: "dashboard",
  components: {
    ActiveBacklog,
    ActiveBacklog2
  },
  data: function() {
    return {
      details: false
    };
  },
  methods: {
    switchView() {
      if (this.details == false) {
        this.details = true;
      } else {
        this.details = false;
      }
    }
  },
  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
